import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TextField from 'Components/forms/text-field/TextField';
import SelectInput from 'Components/forms/select-input/SelectInput.jsx';
import './CreditCardInput.scss';

class CreditCardInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      v1: !Number.isNaN(props.v1) ? props.v1 : '',
      v2: !Number.isNaN(props.v2) ? props.v2 : '',
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      v1: !Number.isNaN(nextProps.v1) ? nextProps.v1 : '',
      v2: !Number.isNaN(nextProps.v2) ? nextProps.v2 : '',
    });
  }

  setField = (e) => {
    const normalizedValue = e.target.value === '' ? '' :
      (e.target.value).toString();
    const internalStateKey = e.target.name === 'last4' ? 'v2' : 'v1';
    const stateKey = e.target.name === 'last4' ? 'end' : 'start';

    if (e.target.value.length >= 6) {
      document.getElementById("last-four-digit").focus();
    }
    if (!Number.isNaN(normalizedValue)) {
      this.setState({ [internalStateKey]: normalizedValue });
      this.props.onChange(this.props.id, stateKey, normalizedValue);
    } else {
      this.setState({ [internalStateKey]: '' });
      this.props.onChange(this.props.id, stateKey, '');
    }
  };

  get labelContent() {
    return (
      <span className="" style={{ fontSize: 11, fontWeight: 'bold' }}>  {/*defect id 42 alignement issue for account number in multiple stage report */}
        {this.props.translations.cardNum}
        {this.props.error && <span className="message-error">{this.props.error}
        </span>}
        {!this.props.error && this.props.labelTooltip}
      </span>
    );
  }

  render() {
    let acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
    return (
      <TextField
        fieldClass="field credit-card-input"
        htmlFor={this.props.id.toString()}
        labelContent={this.labelContent}
        fieldErrorClass="field field-danger credit-card-input"
        error={this.props.error}
        removeFilterAction={this.props.removeFilterAction}
        showDynamicFilter={this.props.showDynamicFilter}
        updatedId={this.props.updatedId}
        labelClass="field-label"
      >
        <div className="credit-card-input-content">   {/*defect id 42 alignement issue for account number in multiple stage report */}
          {this.props.onSelectChange !== null && (
            <div className="credit-card-input-wrapper">
              <SelectInput
                dataList={this.props.cardOptions}
                handleSelection={(event) => this.props.onSelectChange(event)}
                selectedItem={this.props.selectedInput}
                wrapperClass="select-menu__input"
              />
            </div>
          )}
          {this.props.selectedInput.value === 'six-four-digits' ? (
            <span className="multiple-inputs">
              <input
                id={this.props.id}
                type="text"
                className={"field-input field-input_" + acquirerCode}
                onChange={this.setField}
                maxLength="6"
                name="first6"
                placeholder={this.props.translations.first6Placeholder}
                pattern="[0-9.]+"
                value={this.state.v1}
              />
              <input
                type="text"
                id="last-four-digit"
                className={"field-input field-input_" + acquirerCode}
                onChange={this.setField}
                maxLength="4"
                name="last4"
                placeholder={this.props.translations.last4Placeholder}
                pattern="[0-9.]+"
                value={this.state.v2}
              />
            </span>
          ) :
            (
              <input
                id={this.props.id}
                type="text"
                className="field-input"
                onChange={this.setField}
                maxLength={this.props.selectedInput.maxLength}
                name="fullCardNumber"
                pattern="[0-9.]+"
                value={this.state.v1}
              />
            )}
        </div>
      </TextField>
    );
  }
}

CreditCardInput.propTypes = {
  cardOptions: PropTypes.array,
  error: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onSelectChange: PropTypes.func,
  selectedInput: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  labelTooltip: PropTypes.object,
  translations: PropTypes.shape({
    first6Placeholder: PropTypes.string,
    label: PropTypes.string,
    last4Placeholder: PropTypes.string,
    helperText: PropTypes.string,
  }),
  v1: PropTypes.string,
  v2: PropTypes.string,
};

CreditCardInput.defaultProps = {

  selectedInput: {
    value: 'six-four-digits',
    text: 'First 6 / Last 4',
  },
  onSelectChange: null,
  labelTooltip: null,

  cardOption: {
    value: 'six-four-digits',
    text: 'First 6 / Last 4',
  },
  translations: { helperText: '(first 6 or last 4 digits)', first6Placeholder: 'First 6', cardNum: 'Account Number (first 6 or last 4 digits)', last4Placeholder: 'Last 4' },
  v1: '',
  v2: '',
  error: '',
};

export default CreditCardInput;
